<quill-editor
  *ngIf="!readOnly"
  [(ngModel)]="content"
  (onContentChanged)="onContentChanged($event)"
  [sanitize]="true"
  [styles]="{ 'min-height': '250px' }"
  [trimOnValidation]="true"
></quill-editor>
<quill-view *ngIf="readOnly" [content]="content" [sanitize]="true"></quill-view>
